import { IconProps } from './icon';

export function IconBigArrowRight({
  size = '100%',
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="34.2 0 19 25"
      fill="none"
    >
      <path
        d="M52.3352 11.8762C52.6583 12.1993 52.6583 12.7231 52.3352 13.0461L41.0451 24.3362C40.7221 24.6593 40.1983 24.6593 39.8752 24.3362L34.8158 19.2768C34.4927 18.9538 34.4928 18.43 34.8158 18.1069L39.8759 13.0468C40.199 12.7238 40.199 12.2 39.8759 11.8769L34.8144 6.81545C34.4914 6.49238 34.4914 5.96859 34.8144 5.64552L39.8745 0.585451C40.1976 0.262385 40.7214 0.262385 41.0444 0.585451L52.3352 11.8762Z"
        fill={fill}
      />
    </svg>
  );
}
